import Flatpickr from "react-flatpickr";

const DateComponent = ({ value, setter }: any) => (
  <div className="border rounded-full overflow-hidden text-center p-2 border-gray-500">
    <Flatpickr
      className="rounded-full w-full text-center overflow-hidden p-2 outline-none bg-white"
      options={{
        enableTime: true,
        dateFormat: "M d, Y h:i K",
      }}
      data-enable-time
      value={value}
      onChange={([date]) => {
        setter(date);
      }}
    />
  </div>
);
export default DateComponent;
